
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import AuthService from "../../services/authService";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function ResponsiveAppBar({ isHomePage }) {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElAbout, setAnchorElAbout] = React.useState(null);

    const [isLoggedIn, setIsLoggedIn] = React.useState(
        AuthService.isUserLoggedIn()
    );

    React.useEffect(() => {
        setIsLoggedIn(AuthService.isUserLoggedIn());
    }, []);

    const handleOpenNavMenu = (event) =>
        setAnchorElNav(event.currentTarget);

    const handleCloseNavMenu = () =>
        setAnchorElNav(null);

    const navButtonStyle = {
        color: "#d7e8dc",
        fontWeight: 700,
        fontFamily: "'Poppins', sans-serif",
        textTransform: "uppercase",
        fontSize: "13px",
        letterSpacing: "1px",
        px: 2,
        borderRadius: "999px",
        border: "1px solid transparent",
        transition: "all 0.22s ease",

        "&:hover": {
            background: "rgba(125,186,150,.09)",
            borderColor: "rgba(125,186,150,.22)",
            color: "#C5F5D5",
            transform: "translateY(-2px)",
        },
    };

    const dropdownItemStyle = {
        color: "#d7e8dc",
        borderRadius: "8px",
        transition: "all 0.2s ease",
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: "'Poppins', sans-serif",

        "&:hover": {
            background:
                "linear-gradient(90deg,rgba(125,186,150,.16),rgba(125,186,150,.035))",
            color: "#C5F5D5",
            paddingLeft: "20px",
        },
    };

    return (
        <AppBar
            position={isHomePage ? "absolute" : "sticky"}
            elevation={0}
            sx={{
                background:
                    "linear-gradient(110deg,rgba(4,16,11,.98) 0%,rgba(9,31,22,.97) 48%,rgba(3,13,9,.98) 100%)",
                backdropFilter: "blur(20px)",
                borderBottom: "1px solid rgba(125,186,150,.18)",
                borderRadius: { xs: 0, md: "0 0 18px 18px" },
                py: { xs: .5, md: .75 },
                zIndex: 9999,
                boxShadow: "0 14px 40px rgba(0,8,5,.38)",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "2px",
                    background:
                        "linear-gradient(90deg,transparent,#126b3b,#7DBA96,#C5F5D5,#7DBA96,#126b3b,transparent)",
                },
            }}
        >

            <Container maxWidth="xl">

                <Toolbar
                    disableGutters
                    sx={{
                        position: "relative",
                        minHeight: {
                            xs: 58,
                            md: 76,
                        },
                        gap: { xs: 1, md: 0 },
                    }}
                >

                    {/* ================================================= */}
                    {/* DESKTOP BRAND - LEFT */}
                    {/* ================================================= */}

                    <Typography
                        component={Link}
                        to="/"
                        sx={{
                            display: {
                                xs: "none",
                                md: "flex",
                            },

                            position: "relative",
                            flexShrink: 0,
                            mr: { md: 4, lg: 6 },
                            alignItems: "center",
                            justifyContent: "flex-start",
                            textDecoration: "none",
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 900,
                            whiteSpace: "nowrap",
                            textAlign: "left",
                            transition: "transform .25s ease",
                            "&:hover": {
                                transform: "translateY(-1px)",
                            },
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                lineHeight: 1,
                            }}
                        >

                            <Typography
                                sx={{
                                    fontSize: {
                                        md: 22,
                                        lg: 25,
                                    },

                                    fontWeight: 900,

                                    letterSpacing: "-.4px",

                                    color: "#C5F5D5",

                                    textShadow:
                                        "0 0 18px rgba(125,186,150,.24)",
                                }}
                            >
                                Critical Conquer
                            </Typography>

                            <Typography
                                sx={{
                                    mt: .3,

                                    fontSize: {
                                        md: 12,
                                        lg: 13,
                                    },

                                    fontWeight: 900,

                                    letterSpacing: 3,
                                    color: "#7DBA96",
                                }}
                            >
                                THE OLD-SCHOOL CLASSIC SERVER
                            </Typography>

                        </Box>

                    </Typography>


                    {/* ================================================= */}
                    {/* MOBILE MENU */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            flexGrow: 1,
                            display: {
                                xs: "flex",
                                md: "none",
                            },
                        }}
                    >

                        <IconButton
                            size="large"
                            onClick={handleOpenNavMenu}
                            sx={{
                                color: "#7DBA96",

                                border:
                                    "1px solid rgba(125,186,150,.24)",

                                borderRadius: "6px",

                                background:
                                    "rgba(125,186,150,.045)",

                                "&:hover": {
                                    background:
                                        "rgba(125,186,150,.14)",
                                },
                            }}
                        >
                            <MenuIcon />
                        </IconButton>


                        <Menu
                            anchorEl={anchorElNav}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}

                            PaperProps={{
                                sx: {
                                    borderRadius: "14px",
                                    mt: 1.5,
                                    minWidth: 250,

                                    background:
                                        "linear-gradient(145deg,#102719,#06130b)",

                                    border:
                                        "1px solid rgba(125,186,150,.24)",

                                    boxShadow:
                                        "0 20px 50px rgba(0,10,4,.72)",

                                    "&:before": {
                                        content: '""',
                                        display: "block",
                                        height: "2px",
                                        background:
                                            "linear-gradient(90deg,transparent,#7DBA96,transparent)",
                                    },
                                },
                            }}
                        >

                            <MenuItem
                                component={Link}
                                to="/"
                                onClick={handleCloseNavMenu}
                                sx={dropdownItemStyle}
                            >
                                HOME 
                            </MenuItem>

                            <MenuItem
                                component={Link}
                                to="/downloads"
                                onClick={handleCloseNavMenu}
                                sx={dropdownItemStyle}
                            >
                                GET THE CLIENT
                            </MenuItem>

                            <MenuItem
                                onClick={(e) =>
                                    setAnchorElAbout(e.currentTarget)
                                }
                                sx={dropdownItemStyle}
                            >
                                THE GAME
                            </MenuItem>


                            <Menu
                                anchorEl={anchorElAbout}
                                open={Boolean(anchorElAbout)}
                                onClose={() =>
                                    setAnchorElAbout(null)
                                }

                                PaperProps={{
                                    sx: {
                                        background:
                                            "linear-gradient(145deg,#102719,#06130b)",

                                        border:
                                            "1px solid rgba(125,186,150,.24)",

                                        boxShadow:
                                            "0 15px 40px rgba(0,10,4,.68)",
                                    },
                                }}
                            >

                                <MenuItem
                                    component={Link}
                                    to="/ranks"
                                    sx={dropdownItemStyle}
                                >
                                    Hall of Fame
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/marketplace"
                                    sx={dropdownItemStyle}
                                >
                                    Player Market
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/store"
                                    sx={dropdownItemStyle}
                                >
                                    Item Store
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/schedules"
                                    sx={dropdownItemStyle}
                                >
                                    World Schedule
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/updates"
                                    sx={dropdownItemStyle}
                                >
                                    Patch Notes
                                </MenuItem>

                            </Menu>

                        </Menu>

                    </Box>


                    {/* ================================================= */}
                    {/* MOBILE LOGO */}
                    {/* ================================================= */}

                    <Typography
                        component={Link}
                        to="/"
                        sx={{
                            display: {
                                xs: "flex",
                                md: "none",
                            },

                            flexGrow: 1,

                            justifyContent: "center",

                            textDecoration: "none",

                            fontFamily:
                                "'Poppins', sans-serif",

                            fontWeight: 900,

                            lineHeight: 1,

                            color: "#D8FBE3",

                            textShadow:
                                "0 0 15px rgba(125,186,150,.22)",
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >

                            <Typography
                                sx={{
                                    fontSize: 18,
                                    fontWeight: 900,
                                    letterSpacing: 1,
                                }}
                            >
                                Critical Conquer
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 9,
                                    color: "#b8d9c1",
                                    letterSpacing: 3,
                                    mt: .3,
                                }}
                            >
                                THE OLD-SCHOOL REALM
                            </Typography>

                        </Box>

                    </Typography>


                    {/* ================================================= */}
                    {/* DESKTOP NAV */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            flexGrow: 1,

                            display: {
                                xs: "none",
                                md: "flex",
                            },

                            gap: .35,
                            alignItems: "center",
                            justifyContent: "center",
                            pr: 2,
                        }}
                    >

                        <Button
                            component={Link}
                            to="/"
                            sx={navButtonStyle}
                        >
                            Home
                        </Button>


                        <Button
                            component={Link}
                            to="/downloads"
                            sx={navButtonStyle}
                        >
                            Game Client
                        </Button>


                        <Button
                            onClick={(e) =>
                                setAnchorElAbout(
                                    anchorElAbout
                                        ? null
                                        : e.currentTarget
                                )
                            }
                            sx={navButtonStyle}
                        >
                            Explore

                            <ArrowDropDownIcon
                                sx={{
                                    color: "#7DBA96",
                                    fontSize: 20,
                                    ml: .3,
                                }}
                            />
                        </Button>


                        {/* ================================================= */}
                        {/* DROPDOWN */}
                        {/* ================================================= */}

                        <Box
                            sx={{
                                display: anchorElAbout
                                    ? "flex"
                                    : "none",

                                position: "absolute",

                                top: "95%",

                                left: 0,

                                background:
                                    "linear-gradient(145deg,#102719,#06130b)",

                                borderRadius: "14px",
                                p: 2.5,
                                gap: 3,
                                minWidth: "570px",

                                border:
                                    "1px solid rgba(125,186,150,.24)",

                                boxShadow:
                                    "0 25px 60px rgba(0,10,4,.75)",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 25,
                                    right: 25,
                                    height: "2px",
                                    background:
                                        "linear-gradient(90deg,transparent,#7DBA96,transparent)",
                                },
                            }}

                            onMouseLeave={() =>
                                setAnchorElAbout(null)
                            }
                        >

                            {/* CHARACTER & TRADE */}

                            <Box>

                                <Typography
                                    sx={{
                                        color: "#9BCDB0",
                                        fontSize: 10,
                                        fontWeight: 900,
                                        letterSpacing: 2,
                                        mb: 1,
                                        px: 1,
                                    }}
                                >
                                    CHARACTER & TRADE
                                </Typography>

                                <MenuItem
                                    component={Link}
                                    to="/ranks"
                                    sx={dropdownItemStyle}
                                >
                                    Hall of Fame
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/marketplace"
                                    sx={dropdownItemStyle}
                                >
                                    Player Market
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/store"
                                    sx={dropdownItemStyle}
                                >
                                    Item Store
                                </MenuItem>

                            </Box>


                            {/* WORLD INFORMATION */}

                            <Box>

                                <Typography
                                    sx={{
                                        color: "#9BCDB0",
                                        fontSize: 10,
                                        fontWeight: 900,
                                        letterSpacing: 2,
                                        mb: 1,
                                        px: 1,
                                    }}
                                >
                                    WORLD INFORMATION
                                </Typography>

                                <MenuItem
                                    component={Link}
                                    to="/downloads"
                                    sx={dropdownItemStyle}
                                >
                                    Game Client
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/schedules"
                                    sx={dropdownItemStyle}
                                >
                                    World Schedule
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/updates"
                                    sx={dropdownItemStyle}
                                >
                                    Patch Notes
                                </MenuItem>

                            </Box>


                            {/* MEET THE COMMUNITY */}

                            <Box>

                                <Typography
                                    sx={{
                                        color: "#9BCDB0",
                                        fontSize: 10,
                                        fontWeight: 900,
                                        letterSpacing: 2,
                                        mb: 1,
                                        px: 1,
                                    }}
                                >
                                    MEET THE COMMUNITY
                                </Typography>

                                <MenuItem
                                    component="a"
                                    href="https://discord.gg/BeQevF6eqb"
                                    target="_blank"
                                    sx={dropdownItemStyle}
                                >
                                    Join Discord
                                </MenuItem>

                                <MenuItem
                                    component="a"
                                    href="https://www.facebook.com/profile.php?id=61594823784951"
                                    target="_blank"
                                    sx={dropdownItemStyle}
                                >
                                    Facebook Community
                                </MenuItem>

                                <MenuItem
                                    component={Link}
                                    to="/wiki"
                                    onClick={handleCloseNavMenu}
                                    sx={dropdownItemStyle}
                                >
                                    Field Guide
                                </MenuItem>

                            </Box>

                        </Box>

                    </Box>


                    {/* ================================================= */}
                    {/* RIGHT SIDE */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                        }}
                    >

                        {!isLoggedIn ? (
                            <>

                                {/* ================================================= */}
                                {/* SPECIAL LOGIN BUTTON */}
                                {/* ================================================= */}

                                <Button
                                    component={Link}
                                    to="/user/login"
                                    sx={{
                                        color: "#7DBA96",

                                        fontWeight: 800,

                                        fontFamily:
                                            "'Poppins', sans-serif",

                                        fontSize: {
                                            xs: 11,
                                            md: 12,
                                        },

                                        letterSpacing: 1,

                                        px: {
                                            xs: 1.5,
                                            md: 2,
                                        },

                                        py: 1,

                                        border:
                                            "1px solid rgba(125,186,150,.48)",

                                        borderRadius: "999px",

                                        background:
                                            "rgba(125,186,150,.04)",

                                        position: "relative",

                                        overflow: "hidden",

                                        transition: ".3s",

                                        "&:before": {
                                            content: '""',
                                            position: "absolute",
                                            left: 0,
                                            bottom: 0,
                                            width: "100%",
                                            height: "2px",
                                            background:
                                                "#7DBA96",
                                            transform:
                                                "scaleX(0)",
                                            transformOrigin:
                                                "center",
                                            transition: ".3s",
                                        },

                                        "&:hover": {
                                            color: "#D8FBE3",
                                            background:
                                                "rgba(125,186,150,.11)",
                                            borderColor:
                                                "#7DBA96",
                                        },

                                        "&:hover:before": {
                                            transform:
                                                "scaleX(1)",
                                        },
                                    }}
                                >
                                    SIGN IN
                                </Button>


                                {/* ================================================= */}
                                {/* JOIN THE REALM */}
                                {/* ================================================= */}

                                <Button
                                    component={Link}
                                    to="/user/register"

                                    sx={{
                                        background:
                                            "linear-gradient(135deg,#7DBA96,#D8FBE3,#276A4A)",

                                        color: "#06140b",

                                        fontWeight: 900,

                                        fontFamily:
                                            "'Poppins', sans-serif",

                                        fontSize: {
                                            xs: 11,
                                            md: 12,
                                        },

                                        letterSpacing: 1,

                                        px: {
                                            xs: 2,
                                            md: 3,
                                        },

                                        py: 1.2,

                                        borderRadius: "999px",

                                        boxShadow:
                                            "0 5px 20px rgba(125,186,150,.20)",

                                        transition: ".3s",

                                        "&:hover": {
                                            background:
                                                "linear-gradient(135deg,#C5F5D5,#ffe28a,#7DBA96)",

                                            transform:
                                                "translateY(-2px)",

                                            boxShadow:
                                                "0 8px 25px rgba(125,186,150,.36)",
                                        },
                                    }}
                                >
                                    JOIN THE REALM
                                </Button>

                            </>
                        ) : (
                            <>

                                <Button
                                    component={Link}
                                    to="/store"
                                    sx={{
                                        color: "#7DBA96",
                                        fontWeight: 700,
                                        fontSize: 13,
                                    }}
                                >
                                    Item Store
                                </Button>

                                <Button
                                    component={Link}
                                    to="/user/change-password"
                                    sx={{
                                        color: "#d7e8dc",
                                        fontWeight: 700,
                                        fontSize: 13,
                                    }}
                                >
                                    Account Security
                                </Button>

                                <Button
                                    component={Link}
                                    to="/user/logout"
                                    sx={{
                                        color: "#d7e8dc",
                                        fontWeight: 700,
                                        fontSize: 13,

                                        "&:hover": {
                                            color: "#ff7777",
                                        },
                                    }}
                                >
                                    Sign Out
                                </Button>

                            </>
                        )}

                    </Box>

                </Toolbar>

            </Container>

        </AppBar>
    );
}

export default ResponsiveAppBar;

